import { useMemo } from "react";
import { useStore } from "zustand";
import { coreStore } from "@/lib/stores/core-store";

export function useUser() {
	const users = useStore(coreStore, (state) => state.users);

	const getUserDisplayName = useMemo(
		() =>
			(firebaseUid: string): string =>
				// displayName is precomputed at import (TECH-2964).
				users.get(firebaseUid)?.profile?.displayName || firebaseUid,
		[users]
	);

	return { getUserDisplayName };
}
